import React from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
const BlogManagement = () => {
  return <div></div>;
};

export default BlogManagement;
